// extracted by mini-css-extract-plugin
export var content = "_qk-1";
export var fullScreen = "_qk-0";